module.exports = __webpack_public_path__ + "img/bg.b6ff3c53.jpg";